<template>
    <div class="main_bd">
        <div style="margin: 40px 0">
            <a-breadcrumb>
                <span slot="separator" style="color: #000; font-size: 22px">></span>
                <router-link :to="'/market/pages/list'">
                    <a-breadcrumb-item class="b-item-1">Pages List</a-breadcrumb-item>
                </router-link>
                <a-breadcrumb-item class="b-item-2">{{ page_id ? 'Edit the page' : 'Create a new page' }}</a-breadcrumb-item>
            </a-breadcrumb>
        </div>
        <div class="permission">
            <a-form-model ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol" labelAlign="left">
                <div class="form-item">
                    <a-form-model-item ref="title" label="Page Title" prop="title">
                        <a-input v-model="form.title" placeholder="No more than 128 characters" @blur="
                            () => {
                                $refs.title.onFieldBlur();
                            }
                        " :maxLength="128" />
                    </a-form-model-item>
                    <a-form-model-item ref="body" label="Body" prop="body">
                        <a-textarea v-model="form.body" placeholder="No more than 500 characters" @blur="
                            () => {
                                $refs.body.onFieldBlur();
                            }
                        " :maxLength="500" :auto-size="{ minRows: 4, maxRows: 20 }"/>
                    </a-form-model-item>
                    <a-form-model-item label="Image" prop="cover_image" extra="image up to 5MB, image size: 375 * 150. JPG, PNG only">
                        <upload-img :cutwidth="375" :cutheight="150" @upload="upload_cover_image" :photo="form.cover_image"></upload-img>
                    </a-form-model-item>
                    <a-form-model-item label="Related Merchant" prop="related_user_name">
                        <div>
                            <a-auto-complete
                                v-model="form.related_user_name"
                                :data-source="related_user_name_list"
                                style="width: 400px"
                                placeholder="Please input related merchant"
                                :filter-option="filterOption"
                                @select="handleSelect"
                            />
                        </div>
                    </a-form-model-item>
                    <a-form-model-item :wrapper-col="{ span: 14, offset: 14 }">
                        <a-space>
                            <a-button type="link" class="" @click="cancel"> Back </a-button>
                            <a-button @click="submit"> Save </a-button>
                        </a-space>
                    </a-form-model-item>
                </div>
            </a-form-model>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';

    import VueSweetalert2 from "vue-sweetalert2";
    Vue.use(VueSweetalert2);
    import UploadImg from '../../components/UploadImg.vue';

    import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';

    export default {
        name: 'PagesAdd',
        components: { UploadImg },
        data() {
            return {
                sid: window.localStorage.getItem('sid'),
                uname: window.localStorage.getItem('uname'),
                labelCol: { span: 3 },
                wrapperCol: { span: 10 },
                cover_image: '',
                page_id: '',
                form: {
                    title: '',
                    body: '',
                    image_url: '',
                    related_user_name: ''
                },
                rules: {
                    title: [
                        { required: true, message: 'Please Page Title', trigger: 'blur' },
                        { min: 1, max: 128, message: 'No more than 128 characters', trigger: 'blur' }
                    ],
                    body: [
                        { required: true, message: 'Please Body', trigger: 'blur' },
                        { min: 1, max: 512, message: 'No more than 1024 characters', trigger: 'blur' }
                    ]
                },
                related_user_name_list: [],
                filterOption: (input, option) => {
                    return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                },
                user_dict: {},
            };
        },
        beforeMount() {
            let _sid = window.localStorage.getItem('sid') || '';
            let _token = window.localStorage.getItem('token') || '';

            if (!_sid || !_token) {
                window.location.replace('/login');
            }
        },
        async created() {
            const { page_id } = this.$route.query
            if(page_id){
                this.page_id = page_id;
                let res = await this.getPageDetail({
                    page_id: this.page_id
                });

                let { title, body, cover_image, related_sid, related_user_name } = res.info;

                this.form.title = title;
                this.form.body = body;
                this.form.cover_image = cover_image;
                this.form.related_sid = related_sid;
                this.form.related_user_name = related_user_name;
            }
        },
        watch: {
        },
        mounted() {
            this.getMerchantList().then(res => {
                this.related_user_name_list = res.list.map(item => item.user_name);
                this.user_dict = res.list.reduce((acc, item) => {
                    acc[item.user_name] = item.sid;
                    return acc;
                }, {});
            });
        },
        computed: {
            ...mapGetters({
            }),
            ...mapState({
            })
        },
        methods: {
            ...mapActions({
                getPageDetail: 'market/getPageDetail',
                createPage: 'market/createPage',
                getUserList: 'master/getUserList',
                getMerchantList: 'market/getMerchantList',
            }),
            ...mapMutations({
                set_msg: 'app/APP_SET_MSG'
            }),
            cancel() {
                this.$router.go(-1);
            },
            async submit() {
                let {
                    title,
                    body,
                    cover_image,
                    related_sid,
                    related_user_name
                } = this.form;

                let post_data = {
                    page_id: this.page_id,
                    title,
                    body,
                    cover_image,
                    related_sid,
                    related_user_name,
                };

                let res = null;
                res = await this.createPage(post_data);

                if (res && res.code == 100000) {
                    this.$message.success('Save successfully');
                    setTimeout(() => {
                        this.$router.go(-1);
                    }, 1000);
                } else {
                    this.$message.error('Save failed');
                }
            },
            async upload_cover_image(e) {
                this.form.cover_image = e;
            },
            handleSelect(value) {
                this.form.related_user_name = value;
                this.form.related_sid = this.user_dict[value];
            }
        }
    };
</script>

<style>
    
</style>    